import React, { Component } from "react";
import "./../sass/App.scss";
import { withRouter, Route, Switch, Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { fetch } from "./redux/actions";
import "antd/dist/antd.css";
import GravesMap from "./components/graves-map";
import { Row, Col, Button } from "antd";
import Raven from "react-raven";
import List from "./containers/list";
import Grave from "./containers/grave";
import Paths from "./containers/paths";
import Path from "./containers/paths/single_path";
import MyPaths from "./containers/my-paths";
import AboutProject from "./containers/about-project";
import AboutApp from "./containers/about-app/index";
import Menu from "./components/menu";
import TopBar from "./components/top-bar";
import MovableStripe from "./components/movable-stripe";
import ScrollToTop from "./components/scroll-top";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      currentPos: undefined,
      myLoc: undefined,
      showBack: false,
      pathNo: undefined,
      showBackList: false,
      linkTo: undefined,
      logos: undefined,
      keyStr: "0123456789",
    };
    this.myRef = React.createRef();
  }

  scrollTo = (direction) => {
    if (direction === "top") {
      this.myRef.current.scrollTo({ top: 999, behavior: "smooth" });
    } else if (direction === "bottom") {
      this.myRef.current.scrollTo({ top: 100, behavior: "smooth" });
    } else if (direction === "center") {
      this.myRef.current.scrollTo({ top: 300, behavior: "smooth" });
    }
  };

  createHash() {
    let arr = this.state.keyStr.split("");
    let string = "";
    for (let e in arr) {
      string += arr[Math.floor(Math.random() * arr.length)];
    }
    let hash = btoa(string);
    return hash;
  }

  componentDidMount() {
    this.props.dispatch(fetch());
    this.setState({ showMenu: this.props.location.pathname === "/" });
    if (!localStorage.getItem("hash")) {
      localStorage.setItem("hash", this.createHash());
    }
  }

  componentDidUpdate() {
    if (
      this.props.location.pathname.includes("/my-paths") &&
      this.state.linkTo !== "my-paths"
    ) {
      this.setState({ linkTo: "my-paths" });
    } else if (
      this.props.location.pathname === "/list" &&
      this.state.linkTo !== "list"
    ) {
      this.setState({ linkTo: "list" });
    }
    if (
      !this.state.logos &&
      this.props.data.data &&
      this.props.data.data.config &&
      this.props.data.data.config.Logos
    ) {
      this.setState({ logos: this.props.data.data.config.Logos.org });
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    window.location.href.indexOf("localhost") === -1 &&
      Raven.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.props.data.error) {
      return <div>error</div>;
    }

    return localStorage.getItem("hash") ? (
      <main className={`main main--${this.props.data.name}`}>
        {window.location.href.indexOf("localhost") === -1 && (
          <Raven dsn='https://4c22fb7db7f54fd3b31e9c7d85732d61@sentry.qunabu.com/3' />
        )}
        <TopBar
          onShowMyLoc={() => this.setState({ myLoc: !this.state.myLoc })}
          onMenuToggle={() => this.setState({ showMenu: !this.state.showMenu })}
        />

        <Menu
          showMenu={this.state.showMenu}
          onMenuToggle={() => this.setState({ showMenu: !this.state.showMenu })}
        />
        {this.state.showBack ? (
          <Link to={`${this.props.data.name}/path/${this.state.pathNo}`}>
            <div className='back-to-path'>
              <Button>Wróć do ścieżki</Button>
            </div>
          </Link>
        ) : (
          ""
        )}
        {this.state.showBackList ? (
          <Link
            to={
              this.state.linkTo === "my-paths"
                ? `${this.props.data.name}/my-paths/${localStorage.getItem(
                    "hash"
                  )}`
                : `${this.props.data.name}/list`
            }>
            <div className='back-to-path back-to-list'>
              <Button>
                {this.state.linkTo === "my-paths"
                  ? "Wróć do mojej ścieżki"
                  : "Wróć do listy"}
              </Button>
            </div>
          </Link>
        ) : (
          ""
        )}

        {!this.props.data.loading && (
          <div className='container-scroll'>
            <Row gutter={24}>
              <Col
                lg={
                  this.props.history.location.pathname === "/about-app" ||
                  this.props.history.location.pathname === "/about-project"
                    ? 24
                    : 13
                }
                md={
                  this.props.history.location.pathname === "/about-app" ||
                  this.props.history.location.pathname === "/about-project"
                    ? 24
                    : 13
                }
                sm={24}
                xs={24}>
                <div
                  ref={this.myRef}
                  className={
                    this.props.history.location.pathname === "/about-app" ||
                    this.props.history.location.pathname === "/about-project"
                      ? "components-container full-screen bck with-scroll"
                      : this.props.history.location.pathname === "/"
                      ? "components-container"
                      : "components-container with-border with-scroll"
                  }>
                  {this.props.history.location.pathname !== "/" && (
                    <MovableStripe
                      onDirectionMove={(val) => this.scrollTo(val)}
                    />
                  )}
                  {this.myRef.current && (
                    <ScrollToTop el={this.myRef.current}>
                      <Switch>
                        <Redirect
                          from='/'
                          exact
                          to={`/about-project`}
                        />
                        <Route path='/:cemetery/list' component={List} />
                        <Route path='/:cemetery/grave/:id' component={Grave} />
                        <Route path='/:cemetery/paths' component={Paths} />
                        <Route path='/:cemetery/path/:id' component={Path} />
                        <Route
                          path='/:cemetery/my-paths/:hash'
                          component={MyPaths}
                        />
                        <Route path='/about-project' component={AboutProject} />
                        <Route path='/about-app' component={AboutApp} />
                      </Switch>
                    </ScrollToTop>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        )}

        {this.state.logos ? (
          <div className='logos'>
            <img
              alt='logotyps'
              src={`${window.location.origin}${this.state.logos}`}
            />
          </div>
        ) : (
          ""
        )}
        <span className='authors'>
          {/*
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://qunabu.com/'>
            Developed by Qunabu
          </a>{" "}
          |{" "}
          <a href='http://bangbangdesign.pl'>
            Graphic design: bangbangdesign.pl
          </a>
          */}
          <small>Graphic design: bangbangdesign.pl</small>
        </span>

        <GravesMap loading={this.props.data.loading} />
      </main>
    ) : null;
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/js/App.js